import React, { useEffect, useState, useRef } from "react";
import "./TeamLead.css";
import Image1 from "../../../../../assets/ihn/team/advisor1.webp";
import Image2 from "../../../../../assets/ihn/team/advisor2.webp";
import Image3 from "../../../../../assets/ihn/team/mentor.webp";
import FounderImg from "../../../../../assets/ihn/team/founderimg.webp";
import CoFounderImage from "../../../../../assets/ihn/team/co-founder.webp";
import DirectorImg from "../../../../../assets/ihn/team/director.webp";
import Linkedin from "../../../../../assets/logo/linkedin.webp"
import Ambassador1 from "../../../../../assets/ihn/team/ambassador1.webp";
import { useLocation } from "react-router-dom";
import ompl from "../../../../../assets/ihn/team/lead-logo/ompl.webp";
import heritage from "../../../../../assets/ihn/team/lead-logo/heritage.webp";
import ficci from "../../../../../assets/ihn/team/lead-logo/jti.png";
import indigo from "../../../../../assets/ihn/team/lead-logo/indigo.webp";
import Whatsapp from "../../../../../assets/logo/whatsapp.png"


export const Advisors = [
  {
    id: 1,
    slug: "tarun-thakral",
    name: "Tarun Thakral",
    title: "Advisor",
    about: "Tarun Thakral is a distinguished hospitality leader with decades of experience in steering organizations toward sustainable growth, operational excellence, and brand distinction. As Executive Director, he plays a pivotal role in shaping strategic vision, strengthening governance frameworks, and driving long-term value creation across hospitality ventures.With a deep respect for heritage preservation and a forward-thinking executive mindset, Tarun seamlessly blends traditional hospitality values with modern management practices. His leadership philosophy centers on excellence in service delivery, asset optimization, and the cultivation of high-performance teams that consistently exceed industry benchmarks.Renowned for his strategic insight and hands-on leadership approach, Tarun has successfully guided complex hospitality operations through expansion, transformation, and market repositioning. His expertise spans business strategy, stakeholder engagement, operational restructuring, and mentoring senior leadership to deliver sustainable results.Under his guidance, the organization continues to reinforce its commitment to quality, authenticity, and innovation—ensuring that every initiative reflects a balance of legacy, luxury, and long-term growth.",
    position: "Founder & Managing Trustee",
    company: "Heritage Transport Museum",
    image: Image1,
    logo: heritage,
    logolink: "https://www.heritagetransportmuseum.org/",
    alt: "Tarun thakral",
    linkedin: "https://in.linkedin.com/in/tarun-thakral-750952144"
  },
  {
    id: 2,
    slug: "jahnabi-phookan",
    name: "Jahnabi Phookan",
    logo: ficci,
    title: "Advisor",
    about: "Jahnabi Phookan is a distinguished entrepreneur and visionary leader who served as the 37th National President of FICCI Ladies Organization (FLO), the oldest women-led business chamber in Southeast Asia. A pioneer of responsible tourism and women's economic empowerment in Northeast India, she has dedicated her career to creating sustainable livelihoods. As a co-founder of the JTI Group, she instrumentalized the success of award-winning ventures like Jungle Travels India and Assam Bengal Navigation, pioneering long-distance river cruising and eco-luxury hospitality in the Brahmaputra and Ganges regions. Throughout her tenure as National President, Ms. Phookan focused on empowering women with entrepreneurship capabilities and professional excellence, particularly navigating the challenges of the new normal. Her commitment to social justice and skill development is further exemplified through her signature handloom lines, Tribal Heritage and Lahé Looms, which promote the rich artisanal traditions of the Northeast. A recipient of the Honorary Doctorate of Letters (D.Litt.) and an alumna of the Indian Institute of Mass Communication (IIMC) and Indiana University, she continues to serve on several national boards, championing the cause of ethical business and inclusive growth.",
    position: "Director",
    company: "JTI Group & Assam, Bengal Navigation Company",
    alt: "Jahnabi Phookan",
    logolink: "https://www.jtigroup.co.in/",
    image: Image2,
    linkedin: "https://in.linkedin.com/in/jahnabi-phookan-5518658"
  },
];

export const Ambassadors = [
  {
    id: 1,
    slug: "vasudha-sondhi",
    name: "Vasudha Sondhi",
    title: "Ambassador",
    about: "Vasudha Sondhi is a seasoned hospitality and tourism veteran currently serving as the Managing Director of the OMPL Group (Outbound Marketing Pvt. Ltd.). With over three decades of professional experience, she is widely recognized as a trailblazer in the Indian travel market, specializing in integrated sales, marketing, and PR solutions for global luxury hotels and international tourism boards. An alumna of the Institute of Hotel Management (IHM) Mumbai, Vasudha’s career is rooted in prestigious stints with the Taj Group and Hyatt, where she honed her expertise in sales and business development. Since co-founding OMPL in 2002, she has been instrumental in guiding the agency to become a premier representation house, managing a diverse portfolio that includes national tourism offices and elite hospitality brands. Beyond her corporate success, Vasudha is a dedicated advocate for women’s empowerment and sustainable tourism. She serves as the State President for the Uttarakhand Hospitality and Tourism Council under the Women Indian Chamber of Commerce and Industry (WICCI). Her commitment to social responsibility is further evidenced by her role as Chairperson of the Annapurna Charitable Foundation and as the co-founder of Parvada Bungalows, a boutique rural retreat in Nainital. Known for her visionary leadership and unlearn to learn philosophy, she continues to shape the future of curated travel experiences, bridging the gap between global brands and the evolving Indian outbound market.",
    position: "Managing Director",
    company: "Outbound Marketing",
    alt: "Vasudha Sondhi",
    logo: ompl,
    logolink: "https://outboundmarketingindia.com/",
    image: Ambassador1,
    linkedin: "https://www.linkedin.com/in/vasudha-sondhi-7b79291/"
  },];

export const Mentors = [
  {

    id: 1,
    slug: "anil-parashar",
    name: "Anil Parashar",
    title: "Advisor",
    about: "Anil Parashar is a distinguished corporate veteran and a Non-Executive Director known for his profound expertise in strategic leadership, corporate governance, and financial management. With a career spanning several decades, he has held pivotal roles at the highest levels of Indian industry, most notably serving as the former President and CEO of InterGlobe Technology Quotient and as a key board member for InterGlobe Aviation (IndiGo). His journey is marked by a unique ability to navigate complex market dynamics while ensuring long-term institutional stability. A Fellow Member of the Institute of Chartered Accountants of India (ICAI), Mr. Parashar brings a rigorous analytical framework to the boardroom, specializing in business transformation, risk mitigation, and capital structure optimization. As a Non-Executive Director, he acts as a strategic catalyst, providing objective oversight and visionary guidance to ensure organizational alignment with global best practices. His leadership style is defined by a commitment to ethical transparency and the empowerment of management teams to drive sustainable growth. Beyond his corporate accolades, he is recognized as a mentor and a thought leader who has been instrumental in scaling some of India’s most successful brands. His presence on the board offers a wealth of institutional knowledge, making him an invaluable asset in steering the company toward a future of innovation and market leadership.",
    position: "Non Executive Director",
    company: "InterGlobe Aviation & InterGlobe Technology Quotient",
    alt: "Anil Parshar - Indigo",
    image: Image3,
    logo: indigo,
    logolink: "https://www.goindigo.in/",
    linkedin: "https://www.linkedin.com/in/anil-parashar-061634/"
  },
]

const TeamLead = ({ withPageMargin = false, tab, id }) => {
  const [selectedId, setSelectedId] = useState(id || null);

  const tabContainerRef = useRef(null);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(tab?.toLowerCase() || "founder");
  // const [activeTab, setActiveTab] = useState(
  //   tab ? tab.toLowerCase() : null
  // );
  const tabs = [
    { value: "founder", label: "Founder" },
    { value: "co-founder", label: "Co Founder" },
    { value: "mentors", label: "Mentors" },
    { value: "advisors", label: "Advisors" },
    { value: "ambassadors", label: "Ambassadors" },];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlTab = params.get("tab");

    if (urlTab) {
      setActiveTab(urlTab.toLowerCase());
    }
  }, [location.search]);
  useEffect(() => {
    if (!activeTab) {
      setActiveTab("founder");
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      const container = tabContainerRef.current;
      const activeBtn = container?.querySelector(".tab-btn.active");

      if (activeBtn && container) {
        const offset =
          activeBtn.offsetLeft -
          container.offsetWidth / 2 +
          activeBtn.offsetWidth / 2;

        container.scrollTo({
          left: offset,
          behavior: "smooth",
        });
      }
    }
  }, [activeTab]);

  useEffect(() => {
    if (id) {
      // A short delay to ensure the element is rendered before scrolling
      const timer = setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [id, activeTab]);
  useEffect(() => {
    setSelectedId(id || null);
  }, [id]);

  return (
    <div className={withPageMargin ? "page-content" : ""}>
      <section className="teamlead-section">
        <div className="teamlead-container">

          <div className="team-tab-wrapper">

            {/* LEFT ARROW */}
            <button
              className="team-tab-arrow left"
              onClick={() => {
                if (tabContainerRef.current) {
                  tabContainerRef.current.scrollBy({ left: -150, behavior: "smooth" });
                }
              }}
            >
              &#10094;
            </button>
            {/* Tabs */}
            <div className="tab-container" ref={tabContainerRef}>

              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  className={`tab-btn ${activeTab === tab.value ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveTab(tab.value);
                    setSelectedId(null);
                  }}

                >
                  {tab.label}
                </button>
              ))}

            </div>
            <button
              className="team-tab-arrow right"
              onClick={() => {
                if (tabContainerRef.current) {
                  tabContainerRef.current.scrollBy({ left: 150, behavior: "smooth" });
                }
              }}
            >
              &#10095;
            </button>
          </div>
          {/* Content */}
          <div className="tab-content-area">

            {/* Founder */}
            {(activeTab === "founder") && (
              <section id="founder" className="director-page fade-in">

                <div className="director-container">

                  {/* LEFT : IMAGE */}
                  <div className="founder-image-wrapper">
                    <img src={FounderImg} alt="Abhishek Garg - Founder" loading="lazy" className="founder-main-image" />

                    {/* NEW POSITIONING - ABOVE IMAGE BOTTOM-RIGHT */}
                    <a
                      href="https://www.linkedin.com/in/abhigroup"
                      target="_blank"
                      rel="noreferrer"
                      className="founder-linkedin-overlay"
                    >
                      <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
                    </a>
                  </div>

                  {/* RIGHT : SHORT CONTENT */}
                  <div className="director-content">
                    {/* <h1 className="director-title"> The Founder</h1> */}
                    <h2 className="director-name">Abhishek Garg</h2>
                    <div className="scroller mt-2">
                      <p>
                        Abhishek Garg is a lifelong innovator who has spent over 25 years at the forefront of the events and experiential industry. From his beginnings in the high-stakes world of physical weddings and corporate milestones to founding a premier online wedding platform, Abhishek has pioneered the digital evolution of the sector. Today, his platform hosts over 15,000 vendors, ranking among India’s top wedding planners through purely organic growth.
                      </p>
                      <p>
                        With a diverse portfolio spanning Events, Publishing, Real Estate, and Organic Products, Abhishek’s most personal venture is IHN. Launched during the challenges of the pandemic, IHN has blossomed into a thriving ecosystem where business synergies and collaborative success are the new standard. Inspired by the visionary drive of figures like Elon Musk, Abhishek combines a razor-sharp intellect with a deeply humane, down-to-earth approach. He remains dedicated to breaking business barriers while maintaining a core mission of giving back to the universe.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {/* Co-Founder */}
            {(activeTab === "co-founder") && (
              <section id="co-founder" className="director-page fade-in">
                <div className="director-container">

                  {/* LEFT : IMAGE */}
                  <div className="founder-image-wrapper">
                    <img src={CoFounderImage} alt="Punam Singh" className="founder-main-image" />
                    <a
                      href="https://wa.me/918506825000"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="WhatsApp"
                      className="founder-whatsapp-overlay"
                    >
                      <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="founder-overlay-icon" />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/punam-singh-a108ab63/"
                      target="_blank"
                      rel="noreferrer"
                      className="founder-linkedin-overlay"
                    >
                      <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
                    </a>
                  </div>

                  {/* RIGHT : SHORT CONTENT */}
                  <div className="director-content">
                    {/* <h1 className="director-title">Co-Founder</h1> */}
                    <h2 className="director-name">Punam Singh</h2>
                    <div className="scroller mt-2">
                      <p>
                        A seasoned industry veteran with over 30 years of mastery across the Travel, Hospitality, and Mentoring sectors. Punam serves as the strategic bridge between visionary concepts and operational excellence, consistently delivering solutions where others encounter complexity.
                      </p>
                      <p>
                        Guided by the core philosophy of "empowering through leadership," she fosters a culture of responsiveness and authentic connection within the IHN team. Her mission is to cultivate a legacy of professional distinction while driving meaningful impact across the global hospitality landscape.
                      </p>
                    </div>

                  </div>

                </div>
              </section>
            )}

            {/* advisors */}
            {activeTab === "advisors" && (
              <div id="advisors">
                <section className="director-page fade-in">
                  {Advisors
                    .filter(person => !selectedId || person.slug === selectedId)
                    .map((person) => (
                      <div className="director-container" key={person.id} id={person.slug} style={{ marginBottom: "60px" }}>
                        <div className="founder-image-wrapper">
                          <img src={person.image} alt={person.name} className="founder-main-image" />
                          <a
                            href={person.linkedin}
                            target="_blank"
                            rel="noreferrer"
                            className="founder-linkedin-overlay"
                          >
                            <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
                          </a>
                        </div>
                        <div className="director-content">
                          <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                            <div>
                              <h2 className="director-name">{person.name}</h2>
                            </div>
                            <div>
                              <img src={person.logo} alt={`${person.name} logo`} className="lead-logo-img" width="70px" onClick={() => window.open(person.logolink, "_blank")} />
                            </div>
                          </div>

                          <h1 className="director-title">{person.position}</h1>
                          <h1 className="director-company">{person.company}</h1>
                          <div className="scroller">
                            <p>{person.about}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                </section>
              </div>
            )}


            {/* Director */}{/* ambassador */}
            {( activeTab === "ambassadors") && (
              <section id="ambassadors" className="director-page fade-in">
                {Ambassadors
                  .filter(person => !selectedId || person.slug === selectedId)

                  .map((person) => (
                    <div className="director-container" key={person.id} id={person.slug} style={{ marginBottom: "80px" }}>


                      <div className="founder-image-wrapper">
                        <img src={person.image} alt={person.name} className="founder-main-image" />
                        <a
                          href={person.linkedin}
                          target="_blank"
                          rel="noreferrer"
                          className="founder-linkedin-overlay"
                        >
                          <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
                        </a>
                      </div>
                      {/* RIGHT : CONTENT BOX */}
                      <div className="director-content">

                        <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                          <div>
                            <h2 className="director-name">{person.name}</h2>
                          </div>
                          <div>
                            <img src={person.logo} alt={`${person.name} logo`} className="lead-logo-img" width="110px" onClick={() => window.open(person.logolink, "_blank")} />
                          </div>
                        </div>
                        <h1 className="director-title">{person.position}</h1>
                        <h1 className="director-company">{person.company}</h1>
                        <div className="scroller">
                          <p>{person.about}</p>
                        </div>

                        {/* Consistent Action Link */}

                      </div>

                    </div>
                  ))}
              </section>
            )}

            {/* mentor */}

            {( activeTab === "mentors") && (
              <section id="mentors" className="director-page fade-in">
                {Mentors
                  .filter(person => !selectedId || person.slug === selectedId)
                  .map((person) => (
                    <div className="director-container" key={person.id} id={person.slug} style={{ marginBottom: "80px" }}>


                      <div className="founder-image-wrapper">
                        <img src={person.image} alt={person.name} className="founder-main-image" />
                        <a
                          href={person.linkedin}
                          target="_blank"
                          rel="noreferrer"
                          className="founder-linkedin-overlay"
                        >
                          <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
                        </a>
                      </div>
                      {/* RIGHT : CONTENT BOX */}
                      <div className="director-content">
                        <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                          <div>
                            <h2 className="director-name">{person.name}</h2>
                          </div>
                          <div>
                            <img src={person.logo} alt={`${person.name} logo`} className="lead-logo-img" width="80px" onClick={() => window.open(person.logolink, "_blank")} />
                          </div>
                        </div>
                        <h1 className="director-title">{person.position}</h1>
                        <h1 className="director-company">{person.company}</h1>
                        <div className="scroller">
                          <p>{person.about}</p>
                        </div>

                        {/* Consistent Action Link */}

                      </div>

                    </div>
                  ))}
              </section>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamLead;
